import localforage from 'localforage';
import { MswApiService } from '@/shared/msw-api-service';
// import { cscApiService } from '@/shared/api-service/csc-api-service';
interface CacheKeys {
  dataKey: string;
  tsKey: string;
}
interface CachedObjectsConstants {
  prod_list: CacheKeys;
}
export const cachedObjectConstants: CachedObjectsConstants = {
  prod_list: {
    dataKey: 'prod_ist',
    tsKey: 'prod_list_ts',
  },
};
let apiData: any = {};
const productListCache = {
  getProductist(data: any) {
    let productList: Promise<any>;
    productList = MswApiService.tenant.getMsspProductDetails(data)
      .then((response: any) => {
        this.cacheProductListData(response);
        return response;
      });
    apiData = productList;
    return productList;
  },
  cacheProductListData(data: any) {
    if (data !== []) {
      localforage.setItem(cachedObjectConstants.prod_list.dataKey, data);
    }
    return localforage.getItem(cachedObjectConstants.prod_list.dataKey);
  },
  getproductListsData(data: any, isCached: boolean) {
    let productList;
    if (!isCached) {
      productList = this.getProductist(data);
    } else {
      productList = this.getCachedproductListData();
    }
    return productList;
  },
  getCachedproductListData() {
    let productList;
    productList = localforage.getItem(cachedObjectConstants.prod_list.dataKey)
      .then((response) => {
        return response as any;
      });
    return productList;
  },
  isproductListDataChanged() {
    // return localforage.getItem(cachedObjectConstants.prod_list.tsKey)
    //   .then((response) => {
    //     const prodListTs = response;
    //     return cscApiService
    //     .getCloudTenants()
    //     .then((resp: any) => {
    //       localforage.setItem(cachedObjectConstants.prod_list.tsKey, prodListTs);
    //       if (resp.content) {
    //         return true as Boolean;
    //       }
    //       return false as Boolean;
    //     });
    //   });
    // const localDb: any = localforage.getItem(cachedObjectConstants.prod_list.dataKey);
    // const callAPi = apiData.content.totalrec > localDb.content.totalrec ? true :false;
    console.warn('api', apiData);
    return true;
  },
};
export default productListCache;
